import instance from "../axios";

export const getSmartWaiterContent = async (partnerID) => {
    const response = await instance.get(
        "smart_waiter/getDataSmartWaiter.php?partnerID=" + partnerID
    );

    return response.data;
};